import styled from 'styled-components';

export const LentilsWrapper = styled.div<{ $count: number }>`
	padding-top: var(--size-dynamic0050);
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: var(--size-dynamic0100);
	margin-bottom: var(--size-dynamic0100);

	/* ocultar si todas las slides caben en pantalla */
	${({ $count }) => $count <= 1 && `display: none;`}

	@media (min-width: 960px) {
		${({ $count }) => $count <= 2 && `display: none;`}
	}

	@media (min-width: 1600px) {
		${({ $count }) => $count <= 3 && `display: none;`}
	}

	@media (min-width: 2560px) {
		${({ $count }) => $count <= 4 && `display: none;`}
	}
`;

export const VouchersLentilsWrapper = styled.div<{ $count: number; $slidesAt960: number }>`
	padding-top: var(--size-dynamic0050);
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: var(--size-dynamic0100);
	margin-bottom: var(--size-dynamic0100);

	/* ocultar si todas las slides caben en pantalla */
	${({ $count }) => $count <= 1 && `display: none;`}

	@media (min-width: 560px) {
		${({ $count }) => $count <= 2 && `display: none;`}
	}

	@media (min-width: 960px) {
		${({ $count, $slidesAt960 }) => $count <= $slidesAt960 && `display: none;`}
	}

	@media (min-width: 1280px) {
		${({ $count }) => $count <= 3 && `display: none;`}
	}

	@media (min-width: 2560px) {
		${({ $count }) => $count <= 4 && `display: none;`}
	}
`;
